import React, { useEffect, useState } from "react";
import { Check, Circle, Plus, Clock } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/api";
import { PlanAccessRequests } from "./ClientPlanPage";
import { AiPlanCard } from "../../components/planning/PlanningCards";

export default function TimelinePage() {
  const [data, setData] = useState({ groups: [], completed: 0, total: 0 });
  const [showCustom, setShowCustom] = useState(false);
  const [custom, setCustom] = useState({ title: "", due_date: "" });

  async function load() {
    const { data } = await api.get("/timeline");
    setData(data);
  }
  useEffect(() => { load().catch(() => {}); }, []);

  async function toggle(taskId, completed) {
    await api.patch(`/timeline/${taskId}`, { completed: !completed });
    load();
  }
  async function addCustom(e) {
    e.preventDefault();
    if (!custom.title) return;
    await api.post("/timeline/custom", custom);
    setCustom({ title: "", due_date: "" });
    setShowCustom(false);
    toast.success("Task added");
    load();
  }

  const pct = data.total > 0 ? Math.round((data.completed / data.total) * 100) : 0;

  return (
    <div data-testid="timeline-page">
      <div className="mb-6"><PlanAccessRequests /></div>
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-8">
        <div>
          <p className="font-script text-[var(--gold)] text-3xl">Timeline</p>
          <h1 className="font-serif font-light text-4xl">Your wedding journey</h1>
          <p className="text-sm text-[var(--muted)] mt-2">Auto-generated checklist based on your wedding date.</p>
        </div>
        <button onClick={() => setShowCustom(true)} className="btn-outline-gold"><Plus className="w-4 h-4" /> Custom Task</button>
      </div>

      <AiPlanCard onDone={load} />
      <div className="bg-white border border-[var(--line)] rounded-2xl p-6 mb-8">
        <div className="flex items-center justify-between mb-3">
          <p className="text-[11px] uppercase tracking-[0.18em] text-[var(--gold)]">Progress</p>
          <p className="text-sm font-medium">{data.completed} / {data.total} complete</p>
        </div>
        <div className="h-2 rounded-full bg-[var(--bg-warm)]"><div className="h-full bg-[var(--gold)] rounded-full transition-all duration-500" style={{ width: `${pct}%` }} /></div>
      </div>

      {data.groups.length === 0 && (
        <div className="bg-white border border-[var(--line)] rounded-2xl py-16 px-6 text-center">
          <Clock className="w-10 h-10 mx-auto text-[var(--gold)] mb-4" />
          <p className="font-serif text-2xl mb-2">Set your wedding date</p>
          <p className="text-[var(--muted)]">Once you set a date in your Website Builder, we'll auto-generate a beautiful checklist.</p>
        </div>
      )}

      <div className="space-y-6">
        {data.groups.map((g) => (
          <div key={g.milestone} className="bg-white border border-[var(--line)] rounded-2xl p-6">
            <div className="flex items-center justify-between mb-4">
              <p className="text-[11px] uppercase tracking-[0.18em] text-[var(--gold)]">{g.milestone}</p>
              <p className="text-xs text-[var(--muted)]">{g.tasks.filter(t => t.completed).length}/{g.tasks.length}</p>
            </div>
            <div className="space-y-2">
              {g.tasks.map((t) => (
                <button
                  key={t.task_id}
                  data-testid={`task-${t.task_id}`}
                  onClick={() => toggle(t.task_id, t.completed)}
                  className="flex items-center gap-3 w-full py-2 text-left group"
                >
                  {t.completed ? (
                    <div className="w-5 h-5 rounded-full bg-[var(--gold)] flex items-center justify-center"><Check className="w-3 h-3 text-white" /></div>
                  ) : (
                    <Circle className="w-5 h-5 text-[var(--muted)] group-hover:text-[var(--gold)]" />
                  )}
                  <span className={`flex-1 text-sm ${t.completed ? "line-through text-[var(--muted)]" : ""}`}>{t.title}</span>
                  {t.due_date && <span className="text-xs text-[var(--muted)]">{t.due_date}</span>}
                </button>
              ))}
            </div>
          </div>
        ))}
      </div>

      {showCustom && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/40">
          <div className="bg-white rounded-2xl p-8 w-full max-w-md">
            <h3 className="font-serif text-2xl mb-4">Custom Task</h3>
            <form onSubmit={addCustom} className="space-y-4">
              <div><label className="text-[11px] uppercase tracking-[0.16em] text-[var(--muted)]">What needs doing?</label><input required value={custom.title} onChange={(e) => setCustom({...custom, title: e.target.value})} className="input-luxe" /></div>
              <div><label className="text-[11px] uppercase tracking-[0.16em] text-[var(--muted)]">Due date</label><input type="date" value={custom.due_date} onChange={(e) => setCustom({...custom, due_date: e.target.value})} className="input-luxe" /></div>
              <div className="flex gap-3"><button type="button" onClick={() => setShowCustom(false)} className="btn-ghost">Cancel</button><button type="submit" className="btn-gold flex-1">Add Task</button></div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
